export default __webpack_public_path__ + "static/media/624.625edbe9.png";